export default __webpack_public_path__ + "static/media/puzzle-icon.117f838e.svg";